module.exports = __webpack_public_path__ + "img/pesanan_kulioner.9236f3e8.svg";